export class pushCartFreeGift extends window.PURELEI.CustomElement() {
  setupListeners () {
    super.setupListeners()

    if (Object.keys(this.els).length === 0) return

    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(this.els.trigger.element, 'click', this.handleTrigger)
  }

  handleTrigger () {
    const modal = document.querySelector(
      '[data-site-modal-key="free-gift"][data-site-modal-el="modal"]',
    )

    if (!modal) return

    modal.setAttribute('aria-hidden', 'false')
    document.body.classList.toggle('util-SiteOverflowed', true)
  }
}

if (!customElements.get('push-cart-free-gift')) {
  customElements.define('push-cart-free-gift', pushCartFreeGift)
}
